import styled from "@emotion/styled";
import { Button } from "../../../button";
import { datePickerTheme } from "./datePickerTheme";
export const DatePickerMonthSwitchButton = styled(Button)`
    height: 32px;
    width: 32px;

    // A secondary Button's text color, when enabled, would normally be a blueish color, but we want
    // it to be our standard font color. If the button is disabled, we want to keep the color the
    // same as the disabled color the button already uses.
    &:not([aria-disabled="true"]) {
        color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return datePickerTheme.color(themeMode);
}};
    }

    // This ensures the button focus outlines always show above their neighbors.
    z-index: 0;
    &:focus {
        z-index: 1;
    }
`;
//# sourceMappingURL=DatePickerMonthSwitchButton.js.map